<header class="topbar" role="banner">

  <!-- Esquerda: logo + toggle + empresa ativa -->
  <div class="topbar-left">
    <a class="logo" routerLink="." aria-label="Compleet">
      <img src="assets/logo.png" alt="Compleet" class="logo-img" />
    </a>

    <button
      class="topbar-btn toggle-btn desktop-toggle"
      (click)="onToggleSidebar()"
      [attr.aria-label]="sidebarCollapsed() ? 'Expandir menu lateral' : 'Recolher menu lateral'"
      [title]="sidebarCollapsed() ? 'Expandir' : 'Recolher'">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <line x1="2" y1="4.5" x2="16" y2="4.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <line x1="2" y1="9" x2="16" y2="9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <line x1="2" y1="13.5" x2="16" y2="13.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
      </svg>
    </button>

    <button
      class="topbar-btn toggle-btn mobile-toggle"
      (click)="onOpenMobileDrawer()"
      aria-label="Abrir menu de navegação">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <line x1="2" y1="4.5" x2="16" y2="4.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <line x1="2" y1="9" x2="16" y2="9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
        <line x1="2" y1="13.5" x2="16" y2="13.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
      </svg>
    </button>

    <span class="topbar-separator" aria-hidden="true"></span>

    <app-company-selector [(open)]="companySelectorOpen" (companyChange)="onCompanyChange($event)" />
  </div>

  <!-- Centro: ambiente -->
  <div class="topbar-center">
    <app-environment-badge />
  </div>

  <!-- Direita: notificações, ajuda, usuário -->
  <div class="topbar-right">
    <app-notification-menu />

    <button class="topbar-btn help-btn" aria-label="Ajuda" title="Ajuda">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="1.6"/>
        <path d="M6.8 6.9C6.8 5.85 7.7 5 8.9 5C10.1 5 11 5.7 11 6.7C11 7.5 10.5 7.95 9.85 8.35C9.3 8.68 9 9.05 9 9.7V10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="9" y1="12.4" x2="9" y2="12.41" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>

    <span class="topbar-separator" aria-hidden="true"></span>

    <app-user-menu (switchCompany)="onSwitchCompanyRequested()" />
  </div>

</header>
